<ion-header class="transparent absolute">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>
<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme">
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">

        <div class="title my-color-blue" [@enter]>{{'__SC_SUMMARY_HEAD_LEARNER__' | translate}}</div>

        <div class="box" [@enter]>
            <div class="line">
                <div class="el">
                    <div class="circle my-background-red"></div> {{'__SC_SUMMARY_ENTRY__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-black-dark"></div> {{'__SC_SUMMARY_DEVELOPING__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-yellow"></div> {{'__SC_SUMMARY_DELIVERY__' | translate}}
                </div>
            </div>
            <div class="line">
                <div class="el">
                    <div class="circle my-background-blue"></div> {{'__SC_SUMMARY_ADD_DELIVERY__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-green"></div> {{'__SC_SUMMARY_COACH&MENTOR__' | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-grey"></div> {{'__SC_SUMMARY_NOT_COMPLETED__' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="skill-wrap content-wrap">
    <!-- when [active]="true"?  -->
    <ng-container *ngFor="let skillChecker of skillCheckerList; let i = index">
        <app-skills-card [active]="true" [data]="skillChecker"
                         [@leave]></app-skills-card>
    </ng-container>
</div>
<div class="skill-wrap content-wrap" *ngIf="skillCheckerList === null">
    <app-skeleton-list></app-skeleton-list>
</div>
